import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { systemCode } from '..';
import FastbetCart from '../common/betslip-components/FastbetCart';
import MainContext from '../contexts/MainContext';
import { BetslipContext } from '../data/betslip/BetslipConf';
import BetslipLoader from '../data/betslip/BetslipLoader';
import DoubleProfileChooser from '../data/betslip/DoubleProfileChooser';
import { UserContext } from '../data/betslip/UserConf';
import { PvrContext } from '../data/pvr/PvrConf';
import { classIf, getConfiguration } from '../data/utils';
import { WidgetContext } from '../data/widgets/WidgetContext';
import { getLabel } from '../InitData';
import Streaming from '../live/common/Streaming';
import { PageDataContext } from '../PageData';
import { initBetslipEffects } from '../sport-effects';
import { useLayout } from '../UISettingsProvider';
import BetslipContent from './betslip-components/BetslipContent';
import BetslipContentAlt from './betslip-components/BetslipContentAlt';
import FeedWidgetContainer from './betslip-components/FeedWidgetContainer';
import WidgetsContainer from './betslip-components/WidgetsContainer';
import BetslipBanners from './BetslipBanners';
import LiveTv from './live-tv/LiveTv';

function Betslip(props) {
	/*NB! Ogni elemento con classe .widget-betslip deve controllare se il carrello e' in stato "betslipCollapsed" e apporre la .d-none nel caso affermativo */
	
	const betslipRef = useRef(null);
	const mainContext = useContext(MainContext);
	const widgetContext = React.useContext(WidgetContext);
	const ctxs = useRef({}).current;
	ctxs.betslipContext = useContext(BetslipContext);
	const layout = useLayout();
    const userContext = useContext(UserContext);
    const pageDataContext = React.useContext(PageDataContext);
    const pageData = pageDataContext; 
     
    const couponKey = ctxs.betslipContext.betslipData?.selectedCoupon;
    const coupon = ctxs.betslipContext.betslipData?.coupons?.[couponKey];

    
    const [betslipCollapsed, toggleBetslipCollapsed] = useState(false);
    function toggleBetslip() {
        toggleBetslipCollapsed(!betslipCollapsed);
    }
    const [adjustedWidth, setAdjustedWidth] = useState(null); // for the game frame
    const conf = getConfiguration();
    
    const pvrContext = useContext(PvrContext);
	const mountPvrSection = pvrContext.pvrSectionEnabled;
	const frameGames = conf.bfs;
	const showFrames = !mountPvrSection && (frameGames?.fms?.length > 0 ?? false);
	const maxWidthFrames = showFrames ? frameGames.maxw : 0;
	
	const betLoaderVisible = ctxs.betslipContext.getLoaderData().type !== 'hideAll';
	
	const doubleProfileValue = ctxs.betslipContext.provDoubleProfileValue;
	const showDoubleProfleChooser = doubleProfileValue !== null && (userContext.user.logged); 
    useLayoutEffect(function() {
        const body = document.querySelector('.body-sport');
        if (betslipCollapsed) {
        	body && body.classList.add('e-largo-dx');
        } else {
        	body && body.classList.remove('e-largo-dx');
        }
    }, [betslipCollapsed]);
	
	useLayoutEffect(function() {
        initBetslipEffects();

		let maxWidthContainer = betslipRef?.current?.offsetWidth;
		const adjustValue = maxWidthFrames > maxWidthContainer? maxWidthFrames + 25 : maxWidthContainer;
		if (adjustValue !== maxWidthContainer) {
			setAdjustedWidth(adjustValue);
		} else {
            setAdjustedWidth(null);
		}

        return () => {
            mainContext.toggleStreaming(null, null, null);
            widgetContext.setWidget({
                isWidgetToggleable: true
            });
        }
	}, []);

    useEffect(() => {
        if(ctxs.betslipContext.betslipData){
            window.getBetslipSelectionsCount = function() {
                return ctxs.betslipContext.getCouponSelectionsNum();
            }
        }
            
    }, [ctxs.betslipContext.betslipData]);
	
	const styleAttr = {};
	if (adjustedWidth != null) {
		styleAttr.maxWidth = adjustedWidth + "px";
	}
	
    return <> {
    	ctxs.betslipContext.betslipData? 
        <div className={"sidebar-dx col stringimento-sidebar " 
                        + layout.order.sidebarDx  
                        + classIf(betslipCollapsed, 'stringi-dx') } id="sidebar-dx" style={styleAttr} ref={betslipRef}>
            {pageData != null && pageData.cart.topBanners.length > 0 && !betLoaderVisible &&
                <BetslipBanners banners={pageData.cart.topBanners} />
            }
            {!ctxs.betslipContext.betslipData.isBetBuilder && <FastbetCart/>}
            <Streaming container="betslip"/>
            <LiveTv container="betslip" />
            <FeedWidgetContainer betslipCollapsed={betslipCollapsed} />
            <div id="betslip-container" className={"widget-filtro-side margine-giu"  + 
                                                classIf(betslipCollapsed, 'd-none')+
                                                (ctxs.betslipContext.getLoaderData().type !== 'hideAll' ? ' shadowBetting': '')}>
                {conf.bl === 'ALT' ?
                    <BetslipContentAlt toggleBetslip={toggleBetslip} />
                    :
                    <BetslipContent toggleBetslip={toggleBetslip} />
                }
            </div>
            {
            	showDoubleProfleChooser && <DoubleProfileChooser />
            }
            <BetslipLoader />
            {!betslipCollapsed &&
                <WidgetsContainer pageData={pageData} />
            }
            {systemCode === 'MEGAPUESTA' &&
                <div className="d-flex w-100 justify-content-around">
                    <a href="http://jugadoresanonimoscolombia.org/" target="_blank" rel="noopener noreferrer" className="mr-1">
                        <img src={`${process.env.PUBLIC_URL}/assets/img/megapuesta/cfa_logo.png`} alt="" height="80px" width="80px" />
                    </a>
                    <a href="https://megapuesta.co/info/juego-responsable" target="_blank" rel="noopener noreferrer">
                        <img src={`${process.env.PUBLIC_URL}/assets/img/megapuesta/18.webp`} alt="" height="80px" width="80px" />
                    </a>
                </div>
            }
            <div onClick={toggleBetslip} className={"mostra-sidebar-dx pointer bg-nero bianco bordo-tondo margine-giu" + classIf(betslipCollapsed === false, 'd-none')}>
                <i className={"fas fa-chevron-left"} 
                data-toggle="tooltip" 
                data-placement="top" title="" 
                data-original-title="Allarga la schedina"></i>
            </div>
            <div className={"selected-draws-collapsed-bet"  + classIf(betslipCollapsed === false, 'd-none')}> {coupon.totalDraws} </div>
            <div onClick={toggleBetslip} className={"pointer testo-mostra-sidebar-dx allinea-centro h-100" + classIf(betslipCollapsed === false, 'd-none')}>
                <p>{getLabel('carrello.open')}</p>
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="shopping-cart"
                    className="svg-inline--fa fa-shopping-cart fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512">
                    <path fill="currentColor"
                        d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z">
                    </path>
                </svg>
            </div>
        </div>
        :
        <></>
    }
    </>
}

export default Betslip;